import { Alert as MuiAlert, Snackbar } from "components/ui/MaterialAdapter";
import React, { useEffect, useState } from "react";

const Alert = (props) => (
  <MuiAlert elevation={6} variant="filled" {...props} />
);

const TabSwitchDetector = () => {
  const [isTabActive, setIsTabActive] = useState(true);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const handleVisibilityChange = () => {
      const isNowActive = !document.hidden;

      if (isNowActive && !isTabActive) {
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 30000);
      }

      setIsTabActive(isNowActive);
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isTabActive]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShowAlert(false);
  };

  return (
    <>
      {/* Snackbar Alert */}
      <Snackbar
        id="snackbar-tab-switch-warning"
        open={showAlert}
        autoHideDuration={30000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          id="alert-tab-switch-warning"
          onClose={handleClose}
          severity="warning"
          sx={{ width: "100%" }}
        >
          <div className="flex items-center" id="alert-tab-switch-message">
            <p>Detected tab switch! Please focus on the exam.</p>
          </div>
        </Alert>
      </Snackbar>
    </>
  );
};

export default TabSwitchDetector;
